import { render, staticRenderFns } from "./TwilioDebuggingPanel.vue?vue&type=template&id=35bb925c&scoped=true"
import script from "./TwilioDebuggingPanel.vue?vue&type=script&lang=js"
export * from "./TwilioDebuggingPanel.vue?vue&type=script&lang=js"
import style0 from "./TwilioDebuggingPanel.vue?vue&type=style&index=0&id=35bb925c&scoped=true&lang=css"
import style1 from "./TwilioDebuggingPanel.vue?vue&type=style&index=1&id=35bb925c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb925c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bb925c')) {
      api.createRecord('35bb925c', component.options)
    } else {
      api.reload('35bb925c', component.options)
    }
    module.hot.accept("./TwilioDebuggingPanel.vue?vue&type=template&id=35bb925c&scoped=true", function () {
      api.rerender('35bb925c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/TwilioDebuggingPanel.vue"
export default component.exports